import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export async function getStudentProfile(studentId) {
  if (!studentId) return null;

  const ref = doc(db, "users", studentId);
  const snap = await getDoc(ref);

  if (!snap.exists()) return null;

  const data = snap.data();

  return {
    id: snap.id,
    firstName: data.firstName ?? "",
    lastName: data.lastName ?? "",
    email: data.email ?? "",
    createdAt: data.createdAt ?? null,
    lastActive: data.lastActive?.toDate?.() ?? null,
    analytics: data.analytics ?? {},
    pillarEstimates: data.pillarEstimates ?? {},
    estimateHistory: data.estimateHistory ?? {},
  };
}
